/**
 * Comma-separated list of utm_source values that trigger an auth charge during signup.
 * Controlled by env var AUTH_CHARGE_UTM_SOURCES, defaults to 'meta'.
 * Example: 'meta,google,tiktok'
 */
export const AUTH_CHARGE_UTM_SOURCES = (
  process.env.NEXT_PUBLIC_AUTH_CHARGE_UTM_SOURCES || ''
)
  .split(',')
  .map((s) => s.trim().toLowerCase())
  .filter(Boolean);

/**
 * Minimum auth charge amount in cents.
 * If the first month subscription price is lower than this, use this amount instead.
 * This avoids banks blocking very low authorization amounts.
 */
export const AUTH_CHARGE_MIN_CENTS = 150; // $1.50

/**
 * Whether signup should authorize the card. Two independent reasons, OR'd:
 *
 * - The promo code says so (VIVE-3519). A free promo charges $0, so Stripe never
 *   validates the card and the first real charge fails a month later.
 * - The traffic source is on the allowlist (VIVE-3557). Separate concern, still in
 *   use, and being extended to more sources.
 *
 * Either reason alone is enough. An explicit false on a code means "this deal
 * doesn't need one", not "never check this person", so it does not veto the UTM side.
 */
export function shouldAuthorizeCard(
  utmSource: string | undefined,
  requiresAuthorizationCharge: boolean | undefined
): boolean {
  if (requiresAuthorizationCharge === true) return true;

  const utmSourceLower = utmSource?.trim().toLowerCase() || '';
  return !!utmSourceLower && AUTH_CHARGE_UTM_SOURCES.includes(utmSourceLower);
}
